import React, { useState, useEffect } from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import { makeStyles } from '@mui/styles';
import { ReactComponent as Cancel } from "../../assets/images/TicketImages/cancel.svg";

const useStyles = makeStyles({
  paper: {
    transform: 'none',
    opacity: '1',
    transition: 'opacity 242ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, transform 161ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
    transformOrigin: '0px 0px',
    background: '#fff',
    color: '#556575',
    fontSize: '14px',
    fontWeight: '400',
    boxShadow: '0px 5px 5px -3px rgba(0,0,0,0.2), 0px 8px 10px 1px rgba(0,0,0,0.14), 0px 3px 14px 2px rgba(0,0,0,0.12)',
  },
});

const validateEmail = (email) => {
  const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return re.test(String(email).toLowerCase());
};

export default function MultipleEmail(props) {
  const classes = useStyles();
  const [valueStore, setValueStore] = useState([]);
  const [inputValue, setInputValue] = useState('');
  const [error, setError] = useState(false);
  const [helperText, setHelperText] = useState('');

  const {
    name, value, onChange, sendValueStore, id,
  } = props;

  const handleInputChange = (event, newInputValue) => {
    setInputValue(newInputValue.toLowerCase());
    setError(false);
    setHelperText('');
  };

  const handleAddEmail = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      if (inputValue.trim() === '') {
        setError(true);
        setHelperText('Email cannot be empty');
      } else if (!validateEmail(inputValue.trim())) {
        setError(true);
        setHelperText('Invalid email address');
      } else if (valueStore.find((item) => item.email === inputValue.trim())) {
        setError(true);
        setHelperText('Email already added');
      } else {
        const newEmail = { email: inputValue.trim() };
        setValueStore((prevValues) => {
          const updatedValues = [...prevValues, newEmail];
          onChange(event, updatedValues);
          return updatedValues;
        });
        setInputValue(''); // Clear the input value
      }
    }
  };

  useEffect(() => {
    sendValueStore(valueStore, inputValue);
  }, [valueStore, inputValue, sendValueStore]);

  const handleBlur = (event) => {
    if (inputValue.trim() !== '') {
      if (validateEmail(inputValue.trim()) && !valueStore.find((item) => item.email === inputValue.trim())) {
        const newEmail = { email: inputValue.trim() };
        setValueStore((prevValues) => {
          const updatedValues = [...prevValues, newEmail];
          onChange(event, updatedValues);
          return updatedValues;
        });
        setInputValue('');
      }
    }
  };

  const handleChipDelete = (emailToDelete) => () => {
    setValueStore((prevValues) => {
      const updatedValues = prevValues.filter((item) => item.email !== emailToDelete);
      onChange(null, updatedValues);
      return updatedValues;
    });
  };

  return (
    <Stack spacing={3}>
      <Autocomplete

        multiple
        id={id}
        value={valueStore} // ✅ Add this
        options={[]}
        freeSolo
        renderTags={(value, getTagProps) =>
          value.map((option, index) => (
            <Chip
              key={option.email}
              label={option.email}
              {...getTagProps({ index })} // Use getTagProps for onDelete
              deleteIcon={<Cancel />}
              sx={{
                height: "24px",
                backgroundColor: "#F9FAFA",
                border: "1px solid #C5CED6",
                "& .MuiChip-label": {
                  fontSize: "12px",
                  color: "#405261",
                  fontWeight: 500,
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                },
              }}
              onDelete={handleChipDelete(option.email)}
            />
          ))
        }

        // classes={{ paper: classes.paper }}
        onChange={(event, value) => { }}
        size="small"
        sx={{

          // base height
          minHeight: '32px',
          maxHeight: "160px",
          "& .MuiOutlinedInput-root": {
            // base height
            minHeight: '32px',
            maxHeight: "160px",       // max expand height
            display: "flex",
            flexWrap: "wrap",         // allow chips to wrap
            alignItems: "flex-start",
            overflowY: "auto",        // ✅ scroll only vertically
            overflowX: "hidden",
            border: "1px solid #d5dce1",
            padding: "4px 8px",
            transition: "all 0.2s ease",

            "& .MuiOutlinedInput-notchedOutline": { border: "none" },
            "&:hover .MuiOutlinedInput-notchedOutline": { border: "none" },
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": { border: "none" },

            // Scrollbar styles
            "&::-webkit-scrollbar": { width: "6px" },
            "&::-webkit-scrollbar-thumb": {
              backgroundColor: "#C5CED6",
              borderRadius: "4px",
            },
            scrollbarWidth: "thin",
            "-ms-overflow-style": "none",
          },

          "& .MuiAutocomplete-input": {
            marginLeft: "4px",

            padding: "2px 4px !important",
            minWidth: "40px", // keep typing area visible
          },

          "& .MuiAutocomplete-endAdornment": {
            marginTop: "3px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          },

          "& .MuiAutocomplete-popupIndicator": {
            padding: "2px",
            marginRight: "0px",
          },
        }}
        inputValue={inputValue}
        onInputChange={handleInputChange}
        onKeyDown={handleAddEmail}
        onBlur={handleBlur}
        clearIcon={null}
        renderInput={(params) => (
          <TextField
            {...params}
            name={name}
            className="AutoInput"
            placeholder="Type Email and Press Enter..."
            error={error || valueStore.length === 0}
          />
        )}
      />
    </Stack>
  );
}